export const SectionTag = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.25em] text-[#5A5E6B]"
  >
    <span className="h-px w-8 bg-[#2563EB]" />
    {children}
  </div>
);
